/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Slack({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Slack_svg__a)"><path fill="#E01E5A" d="M3.365 10.082c0 .927-.75 1.677-1.676 1.677-.927 0-1.676-.75-1.676-1.677s.749-1.676 1.676-1.676h1.676zm.838 0c0-.927.75-1.676 1.676-1.676.927 0 1.677.75 1.677 1.676v4.19c0 .928-.75 1.677-1.677 1.677s-1.676-.75-1.676-1.676z" /><path fill="#36C5F0" d="M5.88 3.352c-.928 0-1.677-.749-1.677-1.676S4.953 0 5.88 0c.927 0 1.677.75 1.677 1.676v1.676zm0 .851c.926 0 1.676.75 1.676 1.676 0 .927-.75 1.677-1.677 1.677H1.676C.75 7.556 0 6.806 0 5.879s.75-1.676 1.676-1.676z" /><path fill="#2EB67D" d="M12.597 5.88c0-.928.75-1.677 1.676-1.677.927 0 1.676.75 1.676 1.676 0 .927-.749 1.677-1.676 1.677h-1.676zm-.838 0c0 .926-.75 1.676-1.677 1.676-.926 0-1.676-.75-1.676-1.677V1.676C8.406.75 9.156 0 10.082 0c.927 0 1.677.75 1.677 1.676z" /><path fill="#ECB22E" d="M10.083 12.597c.926 0 1.676.749 1.676 1.676s-.75 1.676-1.677 1.676c-.926 0-1.676-.75-1.676-1.676v-1.676zm0-.838c-.927 0-1.677-.75-1.677-1.677s.75-1.676 1.677-1.676h4.203c.927 0 1.676.75 1.676 1.676 0 .927-.75 1.677-1.676 1.677z" /></g><defs><clipPath id="Slack_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;